define('controllers/myreport/myreport-app-promote.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('AppPromoteReport', ['$scope', '$q', 'AppPromote', 'OpenOther', 'auiDialog', 'AppSurveyReport', 'UserInfo', 'reportUtil','ngDialog',
        function ($scope, $q, AppPromote, OpenOther, auiDialog, AppSurveyReport, UserInfo, reportUtil,ngDialog) {
            /* 1. 局部变量声明 */
            var isTaskIdOk = false;

            //错误码集合
            var returnCodeMap = mainCons.appConstant.returnCode;
            //推广报表默认表头筛选结果
            var defaultHeaderResult = {
                dateFilter: {
                    sortType: 0,//1:按顺序 ， 2：按时间区间
                    sortOrder: -1,//0:按时间新到旧  1：按时间旧到新，默认不选中所以写了-1
                    fromTime: '',
                    toTime: ''
                },
                pricingType: '',
                sortResult: ''
            };
            //搜索关键词报表默认表头筛选结果
            var defaultSearchHeaderResult = {
                searchKey: '',
                taskName: '',
                app: '',
                siteType: '',
                matchType: '',
                sortResult: ''
            };
            /* 2. $scope变量声明 */
            var Model = $scope.Model = {
                backup: '',
                tabType: 'install',
                appPromoteType: 'line',
                appSearchType:'bar',
                queryInstall: {
                    // 这里可以什么都不写，直接用默认值
                    //appId: '-1',                    //【产品下拉框】【默认值】-1
                    appTaskId: [],
                    appTaskIdFun: getTaskIDs,
                    regionShow: [0, 7, 5, 6],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 7,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    timeQuantum: 180,
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    queryMethod: queryAllList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadAppPromoteList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                    sortField: 'task,time',
                    sortType: 1,
                    onload: init
                },
                querySearch: {
                    //搜索关键词报表查询配置
                    regionShow: [0, 7, 5, 6],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 7,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    timeQuantum: 180,
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    queryMethod: function() {
                        Model.querySearch.sortField = 'totalConsumeSum';
                        Model.querySearch.sortType = 1;
                        Model.searchTableHeaderResult = angular.copy(defaultSearchHeaderResult);
                        Model.paginationSearch.currentPage = 1;
                        querySearchList();
                    }, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadAppSearchList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                    sortField: 'totalConsumeSum',
                    sortType: 1
                },
                paginationInstall: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeInstall
                },
                paginationSearch: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: function () {
                        querySearchList(true);
                    }
                },
                installList: null,//查询结果
                appIdList: [],
                appList: [],
                taskIdList: [],
                searchList: null,//搜索关键词查询结果
                installCharts: {
                    legendSelectedFun: true,
                    id: "myreport_statistics_install",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                showDayDetail: showDayDetail,//显示每日下载图表
                tableHeaderResult: angular.copy(defaultHeaderResult),
                searchTableHeaderResult: angular.copy(defaultSearchHeaderResult),
                tableHeader: {
                    dateFilter: { //时间筛选输入
                        id: "dateFilter",
                        name: "日期",
                        width: 195, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: function () {
                            var dateInfo = Model.tableHeaderResult.dateFilter;
                            if (dateInfo.sortType == 1 && dateInfo.sortOrder == 1) {
                                //按时间新到旧
                                Model.tableHeaderResult.sortResult = '';
                                Model.queryInstall.sortType = 1;
                                Model.queryInstall.sortField = 'time';
                            } else if (dateInfo.sortType == 1 && dateInfo.sortOrder == 0) {
                                //按时间旧到新
                                Model.tableHeaderResult.sortResult = '';
                                Model.queryInstall.sortType = 0;
                                Model.queryInstall.sortField = 'time';
                            } else if (dateInfo.sortType == 2) {
                                //按时间区间
                                if (dateInfo.fromTime.length == 10 && dateInfo.toTime.length == 10) {
                                    if (!checkTime(dateInfo.fromTime, dateInfo.toTime)) {
                                        return false;
                                    }
                                    Model.tableHeaderResult.sortResult = '';
                                    Model.queryInstall.sortField = 'task,time';
                                    Model.queryInstall.sortType = 1;
                                }
                                else {
                                    return false;
                                }
                            }
                            queryInstallList();
                        }
                    },
                    pricingType: {
                        id: "pricingType",
                        name: "计费类型",
                        choices: [{id: 'ALL', name: '全部'}, {id: 'CPD', name: 'CPD'}, {id: 'CPT', name: 'CPT'}],
                        width: 195, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: queryInstallList
                    },
                    impression: {
                        id: "impression",
                        name: "展示量",
                        choices: [{id: 'impression_0', name: '升序'}, {id: 'impression_1', name: '降序'}],
                        width: 180, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: queryInstallList
                    },
                    download: {
                        id: "download",
                        name: "下载量",
                        choices: [{id: 'download_0', name: '升序'}, {id: 'download_1', name: '降序'}],
                        width: 180, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: queryInstallList
                    },
                    downloadRate: {
                        id: "downloadRate",
                        name: "下载率",
                        choices: [{id: 'downloadRate_0', name: '升序'}, {id: 'downloadRate_1', name: '降序'}],
                        width: 180, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: queryInstallList
                    },
                    money: {
                        id: "money",
                        name: "消耗金额（￥）",
                        choices: [{id: 'money_0', name: '升序'}, {id: 'money_1', name: '降序'}],
                        width: 180, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: queryInstallList
                    },
                    downloadAvgMoney: {
                        id: "downloadAvgMoney",
                        name: "下载均价（￥）",
                        choices: [{id: 'downloadAvgMoney_0', name: '升序'}, {id: 'downloadAvgMoney_1', name: '降序'}],
                        width: 180, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: queryInstallList
                    }

                },
                searchTableHeader: {
                    searchKey: {
                        id: "searchKey",
                        name: "关键词",
                        width:180,
                        queryMethod: querySearchList
                    },
                    taskName: {
                        id: "taskName",
                        name: "推广任务名",
                        width:180,
                        queryMethod:querySearchList
                    },
                    app: {
                        id: "app",
                        name: "应用",
                        width:180,
                        data: querySearchApp,
                        queryMethod: querySearchList
                    },
                    siteType: {
                        id: "siteType",
                        name: "展现样式",
                        choices: [{id: '', name: '全部'}, {id: 'SEARCHLIST', name: '搜索排名'}, {id: 'FASTSEARCH', name: '搜索直达'}],
                        width: 195, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: querySearchList
                    },
                    matchType: {
                        id: "matchType",
                        name: "匹配方式",
                        choices: [{id: '', name: '全部'},{id: 'KEYMATCH', name: '关键词匹配'}, {id: 'AUTOMATCH', name: '自动匹配'}],
                        width: 180, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: querySearchList
                    },
                    searchListAvePrice: {
                        id: "searchListAvePrice",
                        name: "搜索排名均价（￥）",
                        choices: [{id: 'searchListAvePrice_0', name: '升序'}, {id: 'searchListAvePrice_1', name: '降序'}],
                        width: 180, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: querySearchList
                    },
                    fastSearchAvePrice: {
                        id: "fastSearchAvePrice",
                        name: "搜索直达均价（￥）",
                        choices: [{id: 'fastSearchAvePrice_0', name: '升序'}, {id: 'fastSearchAvePrice_1', name: '降序'}],
                        width: 180, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: querySearchList
                    },
                    totalDownloadAll: {
                        id: "totalDownloadAll",
                        name: "推广下载次数",
                        choices: [{id: 'totalDownloadAll_0', name: '升序'}, {id: 'totalDownloadAll_1', name: '降序'}],
                        width: 180, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: querySearchList
                    },
                    totalConsumeSum: {
                        id: "totalConsumeSum",
                        name: "总消耗（￥）",
                        choices: [{id: 'totalConsumeSum_0', name: '升序'}, {id: 'totalConsumeSum_1', name: '降序'}],
                        width: 180, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: querySearchList
                    },
                    aveRanking: {
                        id: "aveRanking",
                        name: "搜索排名",
                        choices: [{id: 'aveRanking_0', name: '升序'}, {id: 'aveRanking_1', name: '降序'}],
                        width: 180, // 非必填参数，如果不传的话，按表头的宽度来
                        queryMethod: querySearchList
                    }
                }
            };
            Model.variableOfScope = 'variable of scope';
            Model.siteType = mainCons.mapWithDefaultConstant.siteType;
            Model.matchType = mainCons.mapWithDefaultConstant.matchType;
            /* 3. $scope函数挂载 */
            $scope.changeTabType = changeTabType;
            $scope.queryDownloadList = queryDownloadList;
            $scope.downloadDownloadList = downloadDownloadList;

            /* 4. 初始化函数声明与执行 */
            function init() {
                //TODO 时间空间校验报错都会弹两次框；此处启用定时器实属下策，待日后优化
                setInterval(closeMoreDialog, 10);
                hideAppTask();
                changeTabType();
            }

            //搜索关键词报表表头查询应用列表用于过滤
            function querySearchApp() {
                var  defer = $q.defer();
                // 获取推广应用列表
                AppPromote.queryPromoteApps({
                    contentAppName : ''
                }).then(function(resp){
                    var list = [];
                    if (resp.promoteAppList) {
                        for(var i =0;i<resp.promoteAppList.length ;i++) {
                            list.push({
                                id : resp.promoteAppList[i].appId,
                                name : resp.promoteAppList[i].appName
                            });
                        }
                    }
                    defer.resolve(list);
                }).catch(function(){
                    defer.resolve([]);
                });
                return defer.promise;
            }

            /* 5. 函数声明 */
            function hideAppTask() {
                angular.element("body").bind('click', function (event) {
                    if (event.target.id != 'appTask') {
                        angular.element('#checkBox4appTask').addClass('ng-hide');
                        angular.element('#appTask').text('选择任务');
                    }
                });

            }

            function changeTabType(type) {
                if (type) {
                    Model.tabType = type;
                }
                switch (Model.tabType) {
                    case 'install':
                        if (Model.installList == null) {
                            queryAllList();
                        }
                        break;
                    case 'search':
                        if (Model.searchList == null) {
                            querySearchList();
                        }
                        break;
                }
            }

            /* 5. 函数声明 */
            function queryDownloadList() {
            }

            function downloadDownloadList() {

            }

            function downloadAppPromoteList() {
                var appTaskId = deleteAllNode();
                var params = {
                    taskIdList: appTaskId || Model.allTaskId,
                    groupIdList: ["ALL"],
                    channelPkgIdList:["ALL"],
                    beginDate:Model.queryInstall.startTime.split('-').join(''),
                    endDate:Model.queryInstall.endTime.split('-').join(''),
                    maxRecCount: 999998,
                    fromRecCount: 1,
                    timeZone:"GMT+8 "
                };
                var list = Model.installList ? Model.installList.taskDateList : '';

                if(!$scope.$parent.checkDate(params,'beginDate','endDate')) {
                    auiDialog.fail("时间区间选择错误","查询时间不得为空");
                    return;
                }

                $scope.$parent.downloadReport(AppPromote.reportPromoAppDown, params, function (resp) {
                    resp.downUrl = resp.reportUrl;
                    return resp && resp.reportUrl;
                },function (resp){
                    if(returnCodeMap[resp.NSP_STATUS]){
                        auiDialog.fail(returnCodeMap[resp.NSP_STATUS]);
                    }else{
                        auiDialog.fail("导出失败。");
                    }
                });

            }

            function downloadAppSearchList() {
                var startTime = Model.querySearch.startTime;
                var endTime = Model.querySearch.endTime;
                var params = {
                    searchKey: Model.searchTableHeaderResult.searchKey,
                    taskName: Model.searchTableHeaderResult.taskName,
                    appIds: Model.searchTableHeaderResult.app ? Model.searchTableHeaderResult.app.join(",") : null,
                    siteType: Model.searchTableHeaderResult.siteType,
                    matchType: Model.searchTableHeaderResult.matchType,
                    dateFilterStart: AUI.DateUtil.date2Str(startTime),
                    dateFilterEnd: AUI.DateUtil.date2Str(endTime),
                    sortField: Model.querySearch.sortField ? Model.querySearch.sortField :'totalConsumeSum',
                    sortType: Model.querySearch.sortType == 0 ? 'ASC' : 'DESC',
                    timeZone:"GMT+8"
                };
                //删除空值参数
                delEmptyParam4Search(params);
                var list = Model.searchList ? Model.searchList.taskSearchKeyReportList : '';

                if(!$scope.$parent.checkDate(params,'dateFilterStart','dateFilterEnd')) {
                    auiDialog.fail("时间区间选择错误","查询时间不得为空");
                    return;
                }

                $scope.$parent.downloadReport(AppPromote.reportPromoAppSearchDown, params, function (resp) {
                    resp.downUrl = resp.reportUrl;
                    return resp && resp.reportUrl;
                },function (resp){
                    if(returnCodeMap[resp.NSP_STATUS]){
                        auiDialog.fail(returnCodeMap[resp.NSP_STATUS]);
                    }
                });

            }

            function queryAllList() {
                // 查询按钮，恢复筛选条件和排序规则
                Model.queryInstall.sortField = 'task,time';
                Model.queryInstall.sortType = 1;
                Model.tableHeaderResult = angular.copy(defaultHeaderResult);
                var time = setInterval(function () {
                    if (isTaskIdOk) {
                        // IE下不知为何会有个disabled属性，导致不可选择，所以要删除该属性
                        queryInstallList(true);
                        clearInterval(time);
                    }
                }, 100);
            }

            function querySearchList(page) {
                var startTime = Model.querySearch.startTime;
                var endTime = Model.querySearch.endTime;
                if (!page) {//非分页查询才需更新查询条件
                    Model.querySearch.sortField = 'totalConsumeSum';
                    Model.querySearch.sortType = 1;
                    Model.paginationSearch.currentPage = 1;
                    if (Model.searchTableHeaderResult.sortResult) {
                        Model.querySearch.sortType = Model.searchTableHeaderResult.sortResult.split("_")[1];
                        Model.querySearch.sortField = Model.searchTableHeaderResult.sortResult.split("_")[0];
                    }
                }

                var params = {
                    searchKey: Model.searchTableHeaderResult.searchKey,
                    taskName: Model.searchTableHeaderResult.taskName,
                    appIds: Model.searchTableHeaderResult.app ? Model.searchTableHeaderResult.app.join(",") : null,
                    siteType: Model.searchTableHeaderResult.siteType,
                    matchType: Model.searchTableHeaderResult.matchType,
                    dateFilterStart: AUI.DateUtil.date2Str(startTime),
                    dateFilterEnd: AUI.DateUtil.date2Str(endTime),
                    sortField: Model.querySearch.sortField,
                    sortType: Model.querySearch.sortType == 0 ? 'ASC' : 'DESC',
                    fromRecCount: 1 + (Model.paginationSearch.currentPage - 1) * Model.paginationSearch.itemsPerPage,
                    maxReqCount: Model.paginationSearch.itemsPerPage
                };

                if(!$scope.$parent.checkDate(params,'dateFilterStart','dateFilterEnd')) {
                    auiDialog.fail("时间区间选择错误","查询时间不得为空");
                    return;
                }

                //删除空值参数
                delEmptyParam4Search(params);
                AppPromote.reportPromoAppBySearchKeys(params).then(function (resp) {
                    Model.searchList = {};
                    if (resp && resp.taskSearchKeyReportList && resp.taskSearchKeyReportList.length > 0) {
                        Model.searchList = resp;
                        Model.paginationSearch.totalCount = resp.totalCount;
                    } else {
                        Model.searchList.taskSearchKeyReportList = [];
                        Model.paginationSearch.totalCount = 0;
                    }
                }).catch(function () {
                    Model.searchList = {};
                    Model.searchList.taskSearchKeyReportList = [];
                });
            }

            /**
             * 删除搜索数据请求参数中的空值
             * @param params
             */
            function delEmptyParam4Search (params) {
                if(!params.searchKey) {
                    delete params.searchKey;
                }
                if(!params.taskName) {
                    delete params.taskName;
                }
                if(!params.appIds || params.appIds.length == 0) {
                    delete params.appIds;
                }
                if(!params.siteType) {
                    delete params.siteType;
                }
                if(!params.matchType) {
                    delete params.matchType;
                }
            }

            function deleteAllNode() {
                var m = {};
                var list = angular.copy(Model.queryInstall.appTaskId);
                var appIdList = angular.copy(Model.appIdList);
                list.forEach(function (al) {
                    m[al] = al;
                });
                appIdList.forEach(function (bl) {
                    delete m[bl];
                });
                delete m['all'];
                var retList = Object.keys(m);
                return retList.length == 0 ? '' : retList;
            }

            function closeMoreDialog() {
                if (angular.element("#appPromoteReport").length > 0 && angular.element(".dialog-cover").length > 1) {
                    angular.element(".icon-close").eq(0).click();
                }
            }

            function checkTime(startTime, endTime) {
                var timeQuantum1 = AUI.DateUtil.calDaysDual(startTime, AUI.DateUtil.date2Str(new Date()));

                if (timeQuantum1 > 1) {
                    auiDialog.fail("时间区间选择错误","开始时间不能晚于今天");
                    return false;
                }

                var timeQuantum2 = AUI.DateUtil.calDaysDual(endTime, AUI.DateUtil.date2Str(new Date()));

                if (timeQuantum2 > 1) {
                    auiDialog.fail("时间区间选择错误","结束时间不能晚于今天");
                    return false;
                }

                var timeQuantum = AUI.DateUtil.calDaysDual(endTime, startTime);
                if (timeQuantum < 1) {
                    auiDialog.fail("时间区间选择错误","开始时间不能晚于结束时间。");
                    return false;
                }

                if (timeQuantum > 180) {
                    auiDialog.fail("时间区间选择错误","时间跨度不能超过180天。");
                    return false;
                }
                return true;
            }

            function queryInstallList(refreshECharts) {
                var noReverse = true;
                var startTime = Model.queryInstall.startTime;
                var endTime = Model.queryInstall.endTime;
                if (refreshECharts) {
                    noReverse = false;
                    Model.installList = {};
                    Model.queryInstall.sortField = 'task,time';
                    Model.queryInstall.sortType = 1;
                    Model.paginationInstall.currentPage = 1;
                    Model.paginationInstall.itemsPerPage = Model.paginationInstall.itemsPerPageBackUp;
                } else {
                    if (Model.tableHeaderResult.sortResult) {
                        Model.tableHeaderResult.dateFilter = {
                            sortType: 0,//1:按顺序 ， 2：按时间区间
                            sortOrder: -1,//0:按时间新到旧  1：按时间旧到新，默认不选中所以写了-1
                            fromTime: '',
                            toTime: ''
                        };
                        Model.queryInstall.sortType = Model.tableHeaderResult.sortResult.split("_")[1];
                        Model.queryInstall.sortField = Model.tableHeaderResult.sortResult.split("_")[0];
                    } else if (Model.tableHeaderResult.dateFilter) {
                        if (Model.tableHeaderResult.dateFilter.fromTime && Model.tableHeaderResult.dateFilter.toTime) {
                            startTime = Model.tableHeaderResult.dateFilter.fromTime;
                            endTime = Model.tableHeaderResult.dateFilter.toTime;
                        }
                    }
                }

                var appTaskId = deleteAllNode();
                var params = {
                    taskIdList: appTaskId || Model.allTaskId,
                    groupIdList: ["ALL"],
                    channelPkgIdList:["ALL"],
                    beginDate: AUI.DateUtil.date2Str(startTime).split('-').join(''),
                    endDate: AUI.DateUtil.date2Str(endTime).split('-').join(''),
                    pricingType: Model.tableHeaderResult.pricingType,
                    sortField: Model.queryInstall.sortField,
                    sortType: Model.queryInstall.sortType == 0 ? 'ASC' : 'DESC',
                    maxRecCount: 999998,
                    fromRecCount: 1
                };
                if (!params.pricingType) {
                    delete params['pricingType'];
                }
                if(!$scope.$parent.checkDate(params,'beginDate','endDate')) {
                    auiDialog.fail("时间区间选择错误","查询时间不得为空");
                    return;
                }
                AppPromote.reportPromoApp(params).then(function (resp) {
                    if (resp && resp.taskDateList && resp.taskDateList.length > 0) {
                        if (refreshECharts) {
                            Model.installList = resp;
                        } else {
                            Model.installList.taskDateList = resp.taskDateList;
                            Model.installList.dateList = resp.dateList;
                        }
                    } else {
                        Model.installList.taskDateList = [];
                        Model.installList.dateList = [];
                    }
                }).catch(function () {
                    Model.installList.taskDateList = [];
                    Model.installList.dateList = [];
                }).finally(function () {
                    Model.paginationInstall.totalCount = Model.installList.taskDateList ? Model.installList.taskDateList.length : 0;
                    if (refreshECharts) {
                        var result = reportUtil.getXYFromBI(Model.installList.dateList, "date", 1,
                            ["downloadAll", "moneyAll", "impressionAll", "downloadAvgMoney", "downloadRate"]);
                        Model.installCharts.options = result && result.date && result.date.length > 0 ? getConfig(result) : null;
                    }
                    pageChangeInstall(noReverse);
                });
            }

            function getConfig(result) {
                return {
                    legend: {
                        data: ['消耗金额', '下载均价', '展示数', '下载率(%)'],
                        selectedMode: 'single',
                        selected: {'下载均价': false, '展示数': false, '下载率(%)': false}
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: result["date"]
                    }],
                    yAxis: [{ // 纵坐标
                        position: 'left',
                        type: 'value',
                        //nameLocation:'left',
                        name: '下载数'
                    }, { // 纵坐标
                        position: 'right',
                        name: '消耗金额',
                        //nameLocation:'right',
                        type: 'value'
                    }],
                    series: [
                        {
                            "name": "消耗金额",
                            "type": Model.appPromoteType,
                            "yAxisIndex": 1,
                            "data": result["moneyAll"]
                        }, {
                            "name": "下载均价",
                            "type": Model.appPromoteType,
                            "yAxisIndex": 1,
                            "data": result["downloadAvgMoney"]
                        }, {
                            "name": "展示数",
                            "type": Model.appPromoteType,
                            "yAxisIndex": 1,
                            "data": result["impressionAll"]
                        }, {
                            "name": "下载数",
                            "type": Model.appPromoteType,
                            "data": result["downloadAll"]
                        }, {
                            "name": "下载率(%)",
                            "type": Model.appPromoteType,
                            "yAxisIndex": 1,
                            "data": result["downloadRate"]
                        }]
                };
            }

            function getSearchConfig(result) {
                return {
                    legend: {
                        data: ['推广下载'],
                        selectedMode:false
                    },
                    xAxis: [{ // 横坐标
                        // axisLabel: {
                        //     rotate: 45,
                        //     margin: 2
                        // },
                        type: 'category',
                        data: result["day"]
                    }],
                    yAxis: [{ // 纵坐标
                        position: 'left',
                        type: 'value',
                        //nameLocation:'left',
                        name: '下载数'
                    }],
                    toolbox: { // 针对报表的一些额外功能。
                        show : false
                    },
                    // grid: {
                    //     y2:100
                    // },
                    series: [
                        {
                            "name": "推广下载",
                            "type": Model.appSearchType,
                            "data": result["download"],
                            itemStyle: {
                                normal: {
                                    color: function(params) {
                                        return "#6495ED"
                                    }
                                }
                            },
                        }]
                };
            }

            /**
             * 显示每日下载趋势图
             */
            function showDayDetail(task) {
                ngDialog.open({
                    template: 'pages/myreport/myreport-searchKeyDayDetail.html',
                    className: '',
                    controller: ['$scope','reportUtil', function ($scopeDlg,reportUtil) {
                        $scopeDlg.closeDayDetail = function(){
                            ngDialog.close();
                        };
                        var params = {
                            searchKey: task.searchKey,
                            taskId: task.taskId,
                            siteType: task.siteType,
                            matchType: task.matchType,
                            dateFilterStart: AUI.DateUtil.date2Str(Model.querySearch.startTime),
                            dateFilterEnd: AUI.DateUtil.date2Str(Model.querySearch.endTime)
                        };
                        $scopeDlg.searchKey = task.searchKey;
                        $scopeDlg.startTime = AUI.DateUtil.date2Str(Model.querySearch.startTime);
                        $scopeDlg.endTime = AUI.DateUtil.date2Str(Model.querySearch.endTime);
                        $scopeDlg.appSearchType='bar';
                        $scopeDlg.searchCharts = {
                            legendSelectedFun: true,
                            id: "myreport_statistics_search",
                            width: "",//非必填参数
                            height: "400",
                            status: 1// 1: 初始化 2:加载完成
                        };
                        var dataList = [];
                        AppPromote.reportBySearchKeyDayDetail(params).then(function (resp) {
                            if(resp && resp.dataList && resp.dataList.length > 0) {
                                var fullList = getFullList(resp.dataList,AUI.DateUtil.stringToDate(Model.querySearch.startTime),AUI.DateUtil.stringToDate(Model.querySearch.endTime));
                                var result = reportUtil.getXYFromBI(fullList, "day", 1,["download"]);
                                $scopeDlg.searchCharts.options = getSearchConfig(result);
                            } else{
                                $scopeDlg.searchCharts.options = null;
                            }
                        }).catch(function () {
                            var list = [];
                            for(var i=0;i<180;i++){
                                list.push({day:i,download:Math.random()});
                            }
                            var resp = {
                                totalCount:180,
                                dataList:list
                            }
                            var result = reportUtil.getXYFromBI(resp.dataList, "day", 0,["download"]);
                            $scopeDlg.searchCharts.options = getSearchConfig(result);
                        });
                    }]
                });
            }

            /**
             * 构造起始时间段内每天的下载数据（没有数据的那天补全为0）
             */
            function getFullList (list,startTime,endTime) {
                list.sort(function (a,b) {
                    return a.day > b.day ? 1: -1;
                });
                var fullList = [];
                var itIndex = 0;
                var tempDate = startTime;
                for (var i = 0;i< 180;i++) {
                    if (tempDate > endTime) {
                        break;
                    }
                    if (list[itIndex] && list[itIndex].day == AUI.DateUtil.date2Str(tempDate)) {
                        fullList.push(list[itIndex]);
                        itIndex++;
                    } else {
                        //没数据，补为0
                        fullList.push({
                            day : AUI.DateUtil.date2Str(tempDate),
                            download : 0
                        });
                    }
                    tempDate = AUI.DateUtil.calDaysLater(tempDate,1);
                }
                return fullList;
            }

            function getTaskIDs() {
                var defer = $q.defer();
                var userObj = UserInfo.get();
                var retData = [];
                //pricingType 为空，默认查询所有计费类型
                var request = {
                    "fromRecCount": 1,
                    "maxReqCount": 99999,
                    "status": "RUN,DONE,MODIFYAUDIT PENDING",
                    "email": userObj.contactEmail,
                    "userRealName": userObj.realName ? userObj.realName : userObj.corpName,
                    "userRegisterAccount": userObj.loginName,
                    "sortType":0,

                };
                AppPromote.queryTaskList(request).then(function (data) {
                    retData = formatData(data.taskList);
                    defer.resolve(retData);
                }).catch(function () {
                    defer.resolve(retData);
                }).finally(function () {
                    isTaskIdOk = true;
                });
                return defer.promise;
            }

            function formatData(appTaskList) {
                var appList = [];
                var appIdList = [];
                var taskList = [];
                var taskIdList = [];
                var retList = [];
                var retListObj = {};
                for (var index in appTaskList) {
                    var data = appTaskList[index];
                    if (!data.contentAppId || !data.contentAppName || !data.taskID || !data.taskName) {
                        continue;
                    }

                    if (retListObj[data.contentAppId]) {
                        var newChild = retListObj[data.contentAppId].children.concat({
                            id: data.taskID,
                            name: data.taskName
                        });
                        retListObj[data.contentAppId] = {
                            id: data.contentAppId,
                            name: data.contentAppName,
                            children: newChild
                        }

                    } else {
                        retListObj[data.contentAppId] = {
                            id: data.contentAppId,
                            name: data.contentAppName,
                            children: [{id: data.taskID, name: data.taskName}]
                        };
                        appIdList.push(data.contentAppId);
                        appList.push({appID: data.contentAppId, appName: data.contentAppName});
                    }
                    taskList.push({taskID: data.taskID, taskName: data.taskName});
                    taskIdList.push(data.taskID);
                }
                Model.queryInstall.appTaskId = taskIdList;
                Model.allTaskId = taskIdList;
                Model.appIdList = appIdList;
                Model.appList = appList;
                for (var dataRet in retListObj) {
                    retList.push(retListObj[dataRet]);
                }
                return {appTaskList: retList, appList: appList, taskList: taskList};
            }

            /**
             * 这里做前台分页，不需要重新查询一次接口
             */
            function pageChangeInstall(noReverse) {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.installList.taskDateList, Model.paginationInstall, true));
                Model.appPromoteList4Show = result.listForShow;
            }


            function pageChangeAppPromote() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.installList.taskDateList, Model.paginationAppPromote));
                Model.appPromoteList4Show = result.listForShow;
            }
        }]
    );
});
